module.exports = __webpack_public_path__ + "static/media/business-news.417b3e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/business-news.png
// module id = 52
// module chunks = 0